import React from "react";
import "./PopupModal.css";

const PopupModal = ({ show, onClose, children }) => {
  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        {/* <button className="close-button" onClick={onClose}>×</button> */}
        {children}
      </div>
    </div>
  );
};

export default PopupModal;
